import MuiTextField, { TextFieldProps } from "@mui/material/TextField";
import React from "react";

export type Props = TextFieldProps;

export const TextField: React.FC<Props> = (props) => {
  return <MuiTextField size="small" variant="outlined" {...props} />;
};
